// Lopes & Co. (E23, 03/10/2026): telas da plataforma dentro do Chatwoot, como item do menu lateral.
import { frontendURL } from '../../../helper/URLHelper';
import KanbanPage from './KanbanPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'lopes_kanban',
    component: KanbanPage,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
